
import Group from 'vux/src/components/group/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'

import DeviceInfo from "./devices/DeviceInfo";
import Topological from "./topological";

export default {
components: {
Topological,
DeviceInfo,
Group,
Tab,
TabItem,
},
name: 'invitation',
data() {
return {
isShow: true,
select: '',
index: 0,
orders_closed: [],
orders_unclosed: [],
list: ['已监控设备', '未监控设备'],
isNet: false
}
},
methods: {
showDevice(index) {
this.orders_closed = this.orders_closed[index].devices.map(item => {
if (item.hasOwnProperty('node')) {
switch (item.node.bonded) {
case 'NO':
item.node.bonded = '未绑定'
break
case 'YES':
item.node.bonded = '已绑定'
break
default:
item.node.bonded = '未知'
}
switch (item.node.level) {
case 1:
item.node.level = '信息'
break
case 2:
item.node.level = '警告'
break
case 3:
item.node.level = '错误'
break
case 4:
item.node.level = '紧急'
break
case 5:
item.node.level = '灾难'
break
}
item.node.connected = item.node.connected === 'NO' ? '未连接' : '已连接';
switch (item.node.status) {
case 'OK':
item.color = '#43d841'
break
case 'WARN':
item.color = '#ffbe00c2'
break
case 'ERROR':
item.color = '#ce2924e6'
break
}
} else if (item.hasOwnProperty('nodes')) {
if (item.nodes.length !== 0) {
if (item.nodes[0].hasOwnProperty('info')) {
item.nodes.forEach(value => {
switch (value.type) {
case 'PowerOff Senser':
value.status = value.info.tem === '-0.0' ? '闭合' : '断开'
break
case 'Smoke Senser':
value.status = value.info.tem === '0.1' ? '正常' : '异常'
break
case 'Flood Senser':
value.status = value.info.tem === '0.1' ? '正常' : '异常'
break
}
value.color = value.info.conn ? '#ffffff87' : '#6f696987';
})
} else {
item.nodes.forEach(value => {
switch (value.bonded) {
case 'NO':
value.bonded = '未绑定'
break
case 'YES':
value.bonded = '已绑定'
break
default:
value.bonded = '未知'
}
switch (value.level) {
case 1:
value.level = '信息'
break
case 2:
value.level = '警告'
break
case 3:
value.level = '错误'
break
case 4:
value.level = '紧急'
break
case 5:
value.level = '灾难'
break
}
value.connected = value.connected === 'NO' ? '未连接' : '已连接';
switch (value.status) {
case 'OK':
value.color = '#43d841'
break
case 'WARN':
value.color = '#ffbe00c2'
break
case 'ERROR':
value.color = '#ce2924e6'
break
}
})
}
}
}
return item
})
this.isShow = false
},
smallbox(data) {
this.$router.push({name: 'smallbox', params: {order: data}})
},
forward(data) {
this.$router.push({name: 'Devicedetails', params: {'order': data}})
},
getData() {
let opid = localStorage.getItem('userid')
let obj = {
headers: {
token: localStorage.getItem('token'),
opid: localStorage.getItem('userid')
}
}
this.$http.get('api/v1/users/' + opid + '/devices', obj).then(res => {

this.orders_closed = res.data.monitors
this.isShow = true

this.orders_unclosed = res.data.orphans
})
},
switchover() {
this.isNet = !this.isNet
}
},
created() {
localStorage.removeItem('equipment')
const openid = localStorage.getItem('openid')
const unionid = localStorage.getItem('unionid')
this.$http.get('api/v1/wechat/' + unionid).then((res) => {




if (res.data.length !== 0) {
this.$http.post('api/v1/wechat/' + unionid + '/token', {'account': res.data[0].account}).then(response => {
localStorage.setItem('token', response.data.token)
localStorage.setItem('userid', response.data.userid)
this.getData()
})
}
})
}
}



// WEBPACK FOOTER //
// ./src/components/Devicelist.vue